import { ApiService } from '../ApiService';
import type {
  RecurringEntry,
  CreateRecurringEntryPayload,
  UpdateRecurringEntryPayload,
  GenerateRecurringResult,
} from '../../../types/recurring-entries';

/**
 * API endpoints pour le module Écritures Récurrentes
 * @see POST /recurring-entries — Créer une écriture récurrente
 * @see GET /recurring-entries — Lister les écritures récurrentes
 * @see GET /recurring-entries/:id — Détail d'une écriture récurrente
 * @see PUT /recurring-entries/:id — Mettre à jour une écriture récurrente
 * @see DELETE /recurring-entries/:id — Supprimer une écriture récurrente
 * @see POST /recurring-entries/generate — Déclencher la génération manuelle
 * 
 * Automatisation : un @Cron(EVERY_DAY_AT_1AM) exécute automatiquement
 * la génération chaque nuit côté backend.
 */
export const recurringEntriesApi = {
  /**
   * Lister toutes les écritures récurrentes
   */
  getAll: (params?: { isActive?: boolean; frequency?: string }) =>
    ApiService.get<{ success: boolean; data: RecurringEntry[] }>('/recurring-entries', params),

  /**
   * Récupérer une écriture récurrente par ID
   */
  getById: (id: string) =>
    ApiService.get<{ success: boolean; data: RecurringEntry }>(`/recurring-entries/${id}`),

  /**
   * Créer une nouvelle écriture récurrente
   */
  create: (data: CreateRecurringEntryPayload) =>
    ApiService.post<{ success: boolean; data: RecurringEntry }>('/recurring-entries', data),

  /**
   * Mettre à jour une écriture récurrente
   */
  update: (id: string, data: UpdateRecurringEntryPayload) =>
    ApiService.put<{ success: boolean; data: RecurringEntry }>(`/recurring-entries/${id}`, data),

  /**
   * Supprimer une écriture récurrente
   */
  delete: (id: string) =>
    ApiService.delete<{ success: boolean }>(`/recurring-entries/${id}`),

  /**
   * Déclencher manuellement la génération de toutes les écritures
   * dont nextRunDate ≤ aujourd'hui et isActive = true
   * 
   * Après génération, nextRunDate est avancée selon la fréquence.
   */
  generate: () =>
    ApiService.post<{ success: boolean; data: GenerateRecurringResult }>('/recurring-entries/generate', {}),
};
